export enum WhatsAppStatus {
    RECEIVE = 'RECEIVE',
    NOT_RECEIVE = 'NOT_RECEIVE',
    NOT_KNOWN = 'NOT_KNOWN'
}